@let formModel = this.formModel();
@let checkBoxFormModel = this.checkBoxFormModel();
@let loading = this.loading();
@let marginWithSuccess = this.marginWithSuccess();

<div [class.my-3]="marginWithSuccess" [class.mt-3]="!marginWithSuccess">
  <h6>{{ 'newVoucher.wl.title' | translate }}</h6>

  <p>{{ 'newVoucher.wl.text' | translate: translate() }}</p>

  <mwe-form #form [formModel]="formModel" (formIsValid)="onFormChange($event, true)" (formIsInvalid)="onFormChange($event, false)" />

  <p class="fw-bold text-blue">{{ 'newVoucher.wl.inputCommit.title' | translate }}</p>

  <mwe-form #checkBoxForm [formModel]="checkBoxFormModel" (formChanged)="onCheckboxFormChange($event)" />

  <div class="row">
    <div class="col-lg-auto">
      <mwe-button
        [labelKey]="'newVoucher.wl.button'"
        [hasMinWidth]="true"
        [hasFullWidth]="true"
        [showSpinner]="loading"
        [disabled]="loading"
        (click)="onClick()"
        data-test="mwe-new-wl-voucher-code-submit"
      />
    </div>
  </div>
</div>
